import React, {Component} from 'react';
import {FormControl, FormGroup, FormControlLabel, Checkbox, withStyles, Grid, Typography} from '@material-ui/core';
import {ExpandMore, ExpandLess} from '@material-ui/icons';

const styles = (theme) => ({
    children: {
        display: 'flex',
        flexDirection:'row',
        paddingLeft:'5px',
        width:"100%",
        color:"#384257",
        alignItems:'center'
    },
    father: {
        display: 'flex',
        backgroundColor:"#e4e7ea",
        width:"100%",
        marginLeft:'-30px',
        paddingRight:'60px',
        flexDirection:'row',
        alignItems:'center'
    },
    group : {
        display: 'flex',
        flexDirection: 'column',
    },
    expandIcon: {
        cursor: 'pointer',
        color:'#384257',
        marginRight:'-50px',
        width:"30px"
    },
    title: {
        fontWeight:'bold',
        fontSize:'15px',
        color:"#384257"
    },
    label: {
        fontSize:'13.5px',
        letterSpacing:'0px',
        color:"#384257",
    },
    number:{
        fontSize:'13.5px',
        marginRight:'40px',
        color:"#384257"
    }
});

class CheckboxGroup extends Component {
    
    state = {
        collapsed: false
    };

    handleCollapse(collapsed){
        this.setState((prevState) => ({ collapsed: !prevState.collapsed }));
    }

    getCheckBox(item, index) {
        const {classes, workAreaCoincidences, statusCoincidences, signed_user, checkboxProps, onChange = () => {}/*, enabledStyle*/} = this.props;
        const {collapsed} = this.state;
        if(index===0){
            return (
                <Grid className={classes.father} key={index}>
                <FormControlLabel
                    style={{paddingLeft:20, marginRight:'auto'}}
                    control={
                        <Checkbox
                            {...checkboxProps}
                            checked={item.checked}
                            onChange={(event) => onChange(item, event.target.checked)}
                            inputProps={{
                                'data-testid': `checkbox-${index}-${item.label}`,
                            }}
                            style={{color:"#384257"}}
                        />
                    }
                    label={<Typography className={classes.title}>{item.label}</Typography>}
                />
                    {( collapsed===false &&
                        <ExpandLess className={classes.expandIcon} onClick={() => this.handleCollapse(collapsed)}/>
                    )}
                    {( collapsed===true&&
                        <ExpandMore className={classes.expandIcon} onClick={() => this.handleCollapse(collapsed)}/>
                    )}
                </Grid>
            );
        }
        else if(collapsed===false){
            return (
                <Grid className={classes.children} key={index}>
                <FormControlLabel
                style={{marginRight:'auto'}}
                    control={
                        <Checkbox
                            {...checkboxProps}
                            checked={item.checked}
                            onChange={(event) => onChange(item, event.target.checked)}
                            inputProps={{
                                'data-testid': `checkbox-${index}-${item.label}`,
                            }}
                            style={{color:"#384257"}}
                        />
                    }
                    label={<Typography className={classes.label}>{item.label}</Typography>}
                />
                    {( workAreaCoincidences!==undefined &&
                        <Typography className={classes.number}>{workAreaCoincidences[index-1]}</Typography>
                    )}
                    {( statusCoincidences!==undefined && signed_user===false &&
                        <Typography className={classes.number}>{statusCoincidences[index]}</Typography>
                    )}
                    {( statusCoincidences!==undefined && signed_user &&
                        <Typography className={classes.number}>{statusCoincidences[index-1]}</Typography>
                    )}
                </Grid>
            );
        }
        return null;
    }



    render() {
        const {data, row, classes} = this.props;
        return (
            <FormControl component="fieldset" style={{width:'100%'}}>
                <FormGroup className={classes.group} row={row}>{(data || []).map((item, index) => this.getCheckBox(item, index))}</FormGroup>
            </FormControl>
        );
    }
}

export default withStyles(styles)(CheckboxGroup);
